import { TickCircle } from "iconsax-react"
import DesktopWrapper from "../../../../layout/desktop/desktop-wrapper"
import TransferForm from "../form"

const DesktopTransfer = () => {
  return (
    <DesktopWrapper title='انتقال اعتبار' icon={<TickCircle />}>
      <TransferForm isMobile={false} />
    </DesktopWrapper>
  )
}

export default DesktopTransfer
